/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { SigninComponent } from "src/app/features/auth-feature/signin/signin.component";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { WhiteshopLoginComponent } from "../../auth-feature/whiteshop-login/whiteshop-login.component";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";

@Component({
  selector: "app-nav-user",
  templateUrl: "./nav-user.component.html",
  styleUrls: ["./nav-user.component.scss"],
})
export class NavUserComponent implements OnInit {
  @Output() closeNav = new EventEmitter();
  isUser;
  userPic = "";
  username = "";
  constructor(
    private dialogService: DialogService,
    private router: Router,
    private dialog: MatDialog,
    public localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    if (
      localStorage.getItem("nVipaniwhiteshopkey") ||
      localStorage.getItem("retailerToken")
    ) {
      this.isUser = true;
      if (localStorage.getItem("userPic")) {
        this.userPic = localStorage.getItem("userPic");
      }
      this.username = JSON.parse(localStorage.getItem("user")).displayName
        ? JSON.parse(localStorage.getItem("user")).displayName
        : JSON.parse(localStorage.getItem("user")).username;
    } else {
      this.isUser = false;
    }
    this.localStorageService.islocalStorageUpdated.subscribe((updated) => {
      if (updated) {
        this.username = JSON.parse(localStorage.getItem("user")).displayName;
      }
    });
  }

  toProfile() {
    this.router.navigateByUrl("/profile");
  }

  toSignIn() {
    this.closeNav.emit();
    this.dialogService.openMatDialog(
      WhiteshopLoginComponent,
      true,
      true,
      null,
      null,
      null,
      true
    );
  }
}
